const GameState = {
	uninitialized: -1,
	playing: 0,
	done: 1,
	results: 2,
};

document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	resultStep: 0,
	healthyJointLabels: [
		// Position is used to know which slot is the right one (order is from top to bottom)
		{ position: 0, label: "Os", description: "" },
		{ position: 1, label: "Membrane synoviale", description: "Elle produit le liquide synovial<sup>2</sup>." },
		{ position: 2, label: "Liquide synovial", description: "Il nourrit et lubrifie les surfaces articulaires<sup>2</sup>." },
		{ position: 3, label: "Cartilage", description: "Il assure le glissement des os et amortit les chocs<sup>1,2</sup>." },
		{ position: 4, label: "Capsule articulaire", description: "Elle délimite l’articulation<sup>2</sup>." },
	],
	osteoarthritisJointLabels: [
		{ position: 1, label: "Amincissement<br />du cartilage", description: "En cas d’arthrose, le cartilage s’use et a tendance à disparaître<sup>1,2,3</sup>." },
		{ position: 2, label: "Inflammation de<br />la membrane synoviale", answerLabel: "Inflammation de la<br />membrane synoviale", description: "En cas d’arthrose, la membrane synoviale est inflammée. Elle produit trop de liquide, ce qui conduit au gonflement de l’articulation<sup>3</sup>.", answer: "La membrane synoviale finit par être inflammée. Elle produit trop de liquide, ce qui conduit au gonflement de l’articulation <sup>3</sup>" },
		{ position: 0, label: "Déformation de l'os", answerLabel: "Déformation<br/>de l'os",description: "En absence de cartilage, l’os a tendance à s’épaissir ou à se fissurer<sup>3</sup>." },
	],
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this.initPlayingState();
				document.getElementById('state-playing').classList.remove('hidden')
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				document.getElementById(`state-results-${this.resultStep}`).classList.remove('hidden')
				break;
		}
	},
	initPlayingState() {
		// Display the labels in random order for the game to be interesting
		function shuffle (t) {
			let last = t.length
			let n;
			while (last > 0) {
				n = 0 | Math.random() * last;
				last -= 1;
				let q = t[n];
				t[n] = t[last];
				t[last] = q;
			}
		}
		shuffle(this.healthyJointLabels);
		shuffle(this.osteoarthritisJointLabels);

		// Fill in the game section
		let leftAnswerHtml = ``;
		let leftLabelsHtml = ``;
		this.healthyJointLabels.forEach((label, i) => {
			leftAnswerHtml += `<div class="drop-area" data-index="${i}" data-side="left"></div>`;
			leftLabelsHtml += `<label class="choice"draggable="true" data-answer="${label.position}" data-description="${label.description}" data-side="left">${label.label}</label>`;
		});
		const leftSection = document.getElementById('game-section-left');
		const leftAnswerArea = leftSection.getElementsByClassName('game-answer-area')[0];
		leftAnswerArea.innerHTML = leftAnswerHtml;
		const leftLabelsArea = leftSection.getElementsByClassName('game-labels-area')[0];
		leftLabelsArea.innerHTML = leftLabelsHtml;

		let rightAnswerHtml = ``;
		let rightLabelsHtml = ``;
		this.osteoarthritisJointLabels.forEach((label, i) => {
			rightAnswerHtml += `<div class="drop-area" data-index="${i}" data-side="right"></div>`;
			rightLabelsHtml += `<label class="choice" draggable="true" data-answer="${label.position}" data-description="${label.description}" data-side="right">${label.label}</label>`;
		});
		const rightSection = document.getElementById('game-section-right');
		const rightAnswerArea = rightSection.getElementsByClassName('game-answer-area')[0];
		rightAnswerArea.innerHTML = rightAnswerHtml;
		const rightLabelsArea = rightSection.getElementsByClassName('game-labels-area')[0];
		rightLabelsArea.innerHTML = rightLabelsHtml;

		this.handleDragAndDrop();
	},
	showingReply: false,
	selectedItem: null,
	successCount: 0,
	handleDragAndDrop() {
		const choicesElements = document.getElementsByClassName("choice");
		for (let i = 0; i < choicesElements.length; i++) {
			choicesElements[i].addEventListener("dragstart", (ev) => {
				if (this.showingReply) {
					// Prevent drag while we're showing the previous response
					ev.preventDefault();
					return;
				}
				ev.dataTransfer.dropEffect = "move";
				this.selectedItem = choicesElements[i];
			});
		}

		const dropZones = document.getElementsByClassName("drop-area");
		for (let i = 0; i < dropZones.length; i++) {
			dropZones[i].addEventListener("dragover", (ev) => {
				ev.preventDefault();
				ev.dataTransfer.dropEffect = "move";
			});
			dropZones[i].addEventListener("drop", (ev) => {
				ev.preventDefault();
				if (this.selectedItem.dataset.side !== dropZones[i].dataset.side) {
					return;
				}
				if (dropZones[i].innerHTML?.length) {
					return; // Already contain something
				}

				// Copy content into drop zone & disable original label
				dropZones[i].innerHTML = `<div class="answer">${this.selectedItem.innerHTML}</div>`;
				this.selectedItem.classList.add("disabled");

				// Show success or error message
				let success = +this.selectedItem.dataset.answer === +dropZones[i].dataset.index;
				this.showingReply = true;

				if (success) {
					const successDiv = document.createElement('div')
					successDiv.innerHTML = `<strong>Exact!</strong> ${this.selectedItem.dataset.description}`;
					successDiv.setAttribute("id", "success-message");
					dropZones[i].appendChild(successDiv);
				} else {
					const errorDiv = document.createElement('div');
					errorDiv.innerHTML = "<strong>Oups !</strong> Ce n'est pas ici.";
					errorDiv.setAttribute("id", "error-message");
					dropZones[i].appendChild(errorDiv);
				}

				// Unlock the game and revert move if needed based on success after 2 sec
				setTimeout(() => {
					if (!success) {
						dropZones[i].innerHTML = '';
						this.selectedItem.classList.remove("disabled");
					} else {
						this.successCount += 1;
						document.getElementById("success-message").remove();
					}
					this.showingReply = false;
					this.selectedItem = null;

					if (this.successCount === this.healthyJointLabels.length + this.osteoarthritisJointLabels.length) {
						// Game is over
						this.showSuccessScreen();
					}
				}, 2000);
			});
		}
	},
	showSuccessScreen() {
		this.state = GameState.done;
		this.render();
	},
	restart() {
		this.state = GameState.playing;
		this.render();
	},
	seeResults(step = 0) {
		this.resultStep = step;
		const labels = step === 0 ? this.healthyJointLabels : this.osteoarthritisJointLabels;

		let answerHtml = ``;
		labels.sort((a, b) => a.position - b.position).forEach(label => {
			answerHtml += `<div class="answer-line"><label class="answer">${label.answerLabel || label.label}</label> <p>${label.answer || label.description}</p></div>`;
		});

		const container = document.getElementById(`state-results-${step}`).getElementsByClassName('result-details')[0];
		container.innerHTML = answerHtml;

		this.state = GameState.results;
		this.render();
	},
}

document.computeSizes();
document.Game.restart();
addEventListener('resize', document.computeSizes);
